module.exports = __webpack_public_path__ + "static/6305-woodrose-38-0e1f4a97c3eab863a9ce4bb7d5e272c2.jpg";